import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CircCommonModule } from "../common/common.module";
import { CirculationsRoutingModule } from "./circulations-routing.module";
import { AddHyperlinkComponent } from "./details/add-hyperlink/add-hyperlink.component";
import { CirculationDetailsComponent } from "./details/circulation-details.component";
import { CurrentStepComponent } from "./details/current-step/current-step.component";
import { CurrentStepForwardedComponent } from "./details/current-step/forwarded/current-step-forwarded.component";
import { StepGridComponent } from "./details/step-grid/step-grid.component";
import { StepStatusComponent } from "./details/step-status/step-status.component";
import { TaskCommentComponent } from "./details/task-comment/task-comment.component";
import { TaskDetailsComponent } from "./details/task-details/task-details.component";
import { DocumentCardComponent } from "./documents/document-card/document-card.component";
import { ListComponent } from "./documents/list/list.component";
import { DocumentUploadComponent } from "./documents/upload/upload.component";
import { CirculationForms } from "./form";
import { BooleanComponent } from "./form/metadata/boolean/boolean.component";
import { ChoiceComponent } from "./form/metadata/choice/choice.component";
import { DataComponent } from "./form/metadata/data.component";
import { DateComponent } from "./form/metadata/date/date.component";
import { NumberComponent } from "./form/metadata/number/number.component";
import { StringComponent } from "./form/metadata/string/string.component";
import { InformationComponent } from "./information/information.component";
import { GridComponent } from "./list/grid/grid.component";
import { ListShellComponent } from "./list/list-shell/list-shell.component";
import { NewFromPreparedComponent } from "./new-from-prepared/new-from-prepared.component";
import { NewFromTemplateComponent } from "./new-from-template/new-from-template.component";
import { ReorderStepsComponent } from "./reorder-steps/reorder-steps.component";
import { StartMultipleCirculationsComponent } from "./start-multiple/start-multiple.component";
import { CirculationEffects } from "./state/circulation.effects";
import { circulationReducer } from "./state/circulation.reducer";

@NgModule({
  declarations: [
    CirculationDetailsComponent,
    InformationComponent,
    AddHyperlinkComponent,
    StepStatusComponent,
    NewFromTemplateComponent,
    NewFromPreparedComponent,
    GridComponent,
    ListShellComponent,
    ReorderStepsComponent,
    TaskDetailsComponent,
    CurrentStepComponent,
    CurrentStepForwardedComponent,
    StepGridComponent,
    TaskCommentComponent,
    ...CirculationForms,
    DocumentUploadComponent,
    ListComponent,
    DocumentCardComponent,
    DataComponent,
    BooleanComponent,
    StringComponent,
    NumberComponent,
    ChoiceComponent,
    DateComponent,
    StartMultipleCirculationsComponent
  ],
  imports: [
    CommonModule,
    CircCommonModule,
    CirculationsRoutingModule,
    StoreModule.forFeature("circulation", circulationReducer),
    EffectsModule.forFeature([CirculationEffects])
  ]
})
export class CirculationsModule {}
